import React from 'react';
import { User, Sparkles } from 'lucide-react';
import { format } from 'date-fns';
import type { ChatMessage as ChatMessageType } from '../../types/chat';

interface ChatMessageProps {
  message: ChatMessageType;
}

export const ChatMessage: React.FC<ChatMessageProps> = ({ message }) => {
  const isUser = message.sender === 'user';

  return (
    <div className={`flex ${isUser ? 'justify-end' : 'justify-start'} mb-4`}>
      <div
        className={`flex max-w-[80%] ${
          isUser ? 'flex-row-reverse' : 'flex-row'
        } items-start space-x-2`}
      >
        <div
          className={`p-3 rounded-lg ${
            isUser
              ? 'bg-purple-500 text-white ml-2'
              : 'bg-white/10 text-purple-200 mr-2'
          }`}
        >
          <p className="text-sm whitespace-pre-wrap leading-relaxed">{message.content}</p>
          {message.timestamp && (
            <p className="text-xs opacity-70 mt-1">
              {format(message.timestamp, 'HH:mm')}
            </p>
          )}
        </div>
        <div
          className={`w-8 h-8 rounded-full flex items-center justify-center ${
            isUser ? 'bg-purple-600' : 'bg-indigo-600'
          }`}
        >
          {isUser ? (
            <User className="w-5 h-5 text-white" />
          ) : (
            <Sparkles className="w-5 h-5 text-white" />
          )}
        </div>
      </div>
    </div>
  );
};